import { render, staticRenderFns } from "./_thick-chart.vue?vue&type=template&id=54d4e6dd&"
import script from "./_thick-chart.vue?vue&type=script&lang=js&"
export * from "./_thick-chart.vue?vue&type=script&lang=js&"
import style0 from "./_thick-chart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports